// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SihaUploadDocumentRequestModel from '../../model/siha-upload-document-request-model';
import SihaUploadDocumentRequestDTO from '../dto/siha-upload-document-request-dto';
import dtoSchema from '../schemas/siha-upload-document-request-schema';

export default abstract class SihaUploadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SihaUploadDocumentRequestDTO>) {
    super();
    if (data) {
      this.uploadFile = data.uploadFile;
    }
  }
  /**
  * @type {binary}
  */
  uploadFile?: File;

  static toModel(dto: DeepPartial<SihaUploadDocumentRequestDTO>): SihaUploadDocumentRequestModel;
  static toModel(dto: DeepPartial<SihaUploadDocumentRequestDTO> | undefined | null): SihaUploadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<SihaUploadDocumentRequestDTO> | undefined | null): SihaUploadDocumentRequestModel | undefined {
    return dto ? new SihaUploadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SihaUploadDocumentRequestModel> | SihaUploadDocumentRequestModel): SihaUploadDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      uploadFile: unwrapped.uploadFile,
    } as SihaUploadDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SihaUploadDocumentRequestModel, can not map to SihaUploadDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
